<div class="dropdown-holder">
    <label class="padded-top-gray-label">{{ title }}</label>
    <div
        *yssIsLoading="isLoading"
        class="normal-text-input dropdown-styled enter-members-field styled-scrolled"
        [ngClass]="{ opened: userDialogOpened }"
        (click)="selectUserDialog()">
        <span *ngIf="!selectedUsers.length">Enter members</span>
        <div
            class="member-chip"
            *ngFor="let user of selectedUsers">
            <div class="user-chip-avatar">
                <app-avatar
                    [user]="user"
                    [fontSize]="'8px'"
                    [fontWeight]="'600'"
                    [showIcons]="false">
                </app-avatar>
            </div>
            <div class="member-chip-name">{{ user.firstname }} {{ user.surname }}</div>
            <div
                class="member-chip-close-icon"
                (click)="removeUser(user, $event)">
                <img src="/assets/images/chat/chip-remove-icon.svg" />
            </div>
        </div>
    </div>
</div>
